import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { usePipe } from './usePipe'

export function useTranslation(key: MaybeRefOrGetter<string | undefined>) {
  const pipe = usePipe()
  const value = computed({
    get: () => {
      return pipe.getTranslation(toValue(key))
    },
    set: (newVal: object) => {
      const safeKey = toValue(key) ?? ''
      if (!safeKey) return
      pipe.setTranslation(safeKey, newVal)
    },
  })
  return value
}
